import styled from 'styled-components';

import { IconButton } from '@xemplo/icon-button';
import { MinBreakpointV2 } from '@xemplo/style-constants';
import { zIndex } from '@xemplo/zindex';

export const CloseButton = styled(IconButton)`
  position: absolute;
  right: 8px;
  z-index: ${zIndex.ModalCloseButton};
  top: 20px;
  @media ${MinBreakpointV2.medium} {
    right: 10px;
    top: 10px;
  }
`;
